import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';

import { NetworkCallService } from '../../../../app/core/services/network-call.service';
import { catchError, switchMap, concatMap, map } from 'rxjs/operators';
import { retryTransientHttpErrors } from '../../../core/operators/retry-transient-http-error.operator';
import { Router } from '@angular/router';
import { IOtpRequest, IOtpResponse } from '../../../core/models/otp.model';
import * as forgotPasscodeLoginConfirmActions from '../actions/forgot-passcode-login-confirm.actions';
import { HelpersService } from '../../../../../src/app/core/services/helpers.service';
import notify from 'devextreme/ui/notify';

@Injectable()
export class ForgotPasscodeLoginConfirmEffects {
  constructor(
    private actions$: Actions,
    private networkCallService: NetworkCallService,
    private router: Router,
    private helperService: HelpersService
  ) {}

  forgotPasscodeLoginConfirm$ = createEffect(() =>
    this.actions$.pipe(
      ofType(forgotPasscodeLoginConfirmActions.loadForgotPasscodeLoginConfirms),
      switchMap(action =>
        this.networkCallService.post<IOtpRequest, IOtpResponse>('Authentication/businessLoginConfirm', action.request).pipe(
          map(response => {
            if (response.success && response.accessToken !== null) {
              sessionStorage.setItem('token', response.accessToken);
              this.helperService.decodeJwtToken(response.accessToken);
              this.router.navigateByUrl('auth/forgot-passcode');
            } else if (!response.success && response.accessToken === null && !response.otpExpired) {
              this.helperService.notifyError(`Please check your OTP and try again.`, 300, 3000);
            } else if (!response.success && response.accessToken === null && response.otpExpired) {
              this.helperService.notifyError(`OTP Expired, your OTP has expired. Please resend a new one.`, 300, 3000);
            }
            return forgotPasscodeLoginConfirmActions.loadForgotPasscodeLoginConfirmsSuccess({ response });
          }),
          retryTransientHttpErrors(),
          catchError(error => {
            return of(forgotPasscodeLoginConfirmActions.loadForgotPasscodeLoginConfirmsFailure(error));
          })
        )
      )
    )
  );
}
